import React from 'react';
import { Backdrop, CircularProgress, Typography } from '@mui/material';

const LoadingOverlay = ({ isOpen, text = '', spinnerColor = 'primary' }) => {
    return (
        <Backdrop
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: (theme) => theme.zIndex.drawer + 1, // Asegura que esté por encima de otros elementos
            }}
            open={isOpen}
        >
            <CircularProgress color={spinnerColor} />
            {
                text &&
                <Typography variant='overline'>Cargando contenido...</Typography>
            }
        </Backdrop>
    );
};

export default LoadingOverlay;
